import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurRecognitionTab4Table({trainers, handleModalClick}) {
  return (
    <div className="table-wrapper">
      <table id="formateur-list-table">
        <caption id="formateur-list-caption" className="sr-only">{window.Drupal.t('fournisseur.trainers.listing.table.title')}</caption>
        <thead>
        <tr>
          <th width="30%">{window.Drupal.t('fournisseur.gestion.table.firstname')}</th>
          <th width="30%">{window.Drupal.t('fournisseur.gestion.table.lastname')}</th>
          <th>{window.Drupal.t('fournisseur.gestion.table.email')}</th>
        </tr>
        </thead>
        <tbody>

        {trainers && trainers.length === 0 ? (
            <tr>
              <td colSpan="6">
                <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
              </td>
            </tr>
        ) : (
          trainers.map((item) => (
            <tr key={item.Contact_Id}>
              <td>{item.First_Name}</td>
              <td>{item.Last_Name}</td>
              <td>{item.Contact_Email__Rn_Descriptor}</td>
            </tr>
          )))}
        </tbody>
      </table>
    </div>
  );
}

CsfPivotalFournisseurRecognitionTab4Table.propTypes = {
  trainers: PropTypes.array,
  handleModalClick: PropTypes.func,
};
